import { defineStore } from 'pinia';

import { useLocalStorage } from '@vueuse/core';

const useXsrfTokenStore = defineStore('xsrf-token', () => {
  const xsrfToken = useLocalStorage('XSRF-TOKEN-X', '');

  function setXsrfToken(value: string): void {
    xsrfToken.value = value;
  }

  return {
    xsrfToken,
    setXsrfToken,
  };
});

export default useXsrfTokenStore;
